export function TurnaroundInspectionLogo({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" fill="#0030C2" />
        <path
          d="M10.9997 36V33.3334H26.333V36H10.9997ZM13.333 29.3334L8.33301 21L11.533 20.1334L15.2663 23.2667L19.933 22.0334L13.033 12.8334L16.8997 11.8L26.8663 20.1667L32.533 18.6334C33.2441 18.4334 33.9163 18.5167 34.5497 18.8834C35.183 19.25 35.5997 19.7889 35.7997 20.5C35.9997 21.2112 35.9163 21.8834 35.5497 22.5167C35.183 23.15 34.6441 23.5667 33.933 23.7667L13.333 29.3334Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43 34C43 37.866 39.866 41 36 41C32.134 41 29 37.866 29 34C29 30.134 32.134 27 36 27C39.866 27 43 30.134 43 34ZM40.5451 31.7396L34.7604 37.5L31.4549 34.2187L32.6944 32.9792L34.7604 35.0208L39.3056 30.5L40.5451 31.7396Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default TurnaroundInspectionLogo;
